import { z } from 'zod';
export const hhccnValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        language: z.enum(['en', 'es', 'zh', 'ko', 'vi']).default('en'),
        startingDate: z.string().min(10, 'Starting date is required'),
        changes: z
            .array(z.object({
            service: z.string(),
            reason: z.string(),
        }))
            .optional(),
        noticeReason: z.enum(['doctor-order', 'agency-decision']),
        optionalDetails: z.string().optional(),
        representativeSigned: z.boolean().optional(),
        patientSigned: z.literal(true, {
            errorMap: () => ({ message: 'Patient or authorized representative signature is required' }),
        }),
        signedDate: z.string().min(10, 'Signed date is required'),
    }),
});
